import { observer } from 'mobx-react-lite';
import alertsStore from '@context/global/mobx/alertStore';
import Alert from '@components/Alerts/Alert';
import styles from '@components/Alerts/Alerts.styles';
const Alerts = () => {
  const alerts = alertsStore;
  if (alerts.alerts.length === 0 || !alerts.currentAlert) {
    return null;
  }
  return <div sx={styles.container}>
      <div sx={styles.overlay} />
      <Alert key={Math.random()} alert={alerts.currentAlert} />
    </div>;
};
export default observer(Alerts);